/**
 * Language list diff helpers.
 *
 * Kept separate from edit hooks so V2 dialogs can use the pure helpers without
 * importing legacy screen-localization services.
 */

export function getLanguagesToRemove<T extends string>(
  currentLanguages: T[],
  newLanguages: T[]
): T[] {
  const newSet = new Set(newLanguages);
  return currentLanguages.filter((lang) => !newSet.has(lang));
}

export function getLanguagesToAdd<T extends string>(
  currentLanguages: T[],
  newLanguages: T[]
): T[] {
  const currentSet = new Set(currentLanguages);
  return newLanguages.filter((lang) => !currentSet.has(lang));
}
